// extracted by mini-css-extract-plugin
export default {"root":"DeleteButton_root__R4JIN","icon":"DeleteButton_icon__g4V-i"};